import React, { useRef } from "react";
import ReactDOM from "react-dom";
import { auth } from "../services/auth";
import { Button } from "@magnetic/react-components";
import { StyledDialog } from "./Dialog.styled";
import { ThemeProvider, getTheme } from "@magnetic/react-components";  

interface ReloginModalProps {
  onSignOut(): any;
  manualLogin(): any;
  spLogin(): any;
}


export class ReloginModal extends React.Component<ReloginModalProps> {
  private passwordInput: any = null;
  private isSso: boolean = auth.isSsoAuthMode;

  constructor(props: ReloginModalProps) {
    super(props);    
  }
  

  render() {
    const handleSignOut = () => this.props.onSignOut();
    const handleContinue = (e: any) => {
      if ( !this.isSso ) {
        this.props.manualLogin();
      } else {
        this.props.spLogin();
      }
      e.preventDefault();
    };
    
    let msg = "Your session expired due to inactivity. Log in to continue.";
    if (this.isSso && !auth.audience) {
      msg = "Your enlyte360 session has expired due to inactivity. Please close all enlyte360 browser tabs and re-start your session by clicking on your company’s internal Enlyte SSO link."
    }

    const Footer = (isSso:boolean) => {     
      if ( isSso && !auth.audience ) {
        return null;
      } 

      if ( isSso && auth.audience ) {
        return <>          
          <Button type="submit" onClick={handleContinue}>Log In</Button>          
        </>
      } 

      return (
        <>
          <Button type="button" onClick={handleSignOut}>Sign Out</Button>
          <Button type="submit" onClick={handleContinue}>Log In</Button>          
        </>   
      )  
    }
  
    return ( 
      <ThemeProvider theme={getTheme("Enlyte")}>
      <StyledDialog title={"Session Expired"} isModal={true} isOpen={true} onCancel={handleSignOut} style={{}} className="relogin" footer={Footer(this.isSso)}>
          <div style={{ padding: "2rem" }}>{msg}</div>                    
      </StyledDialog>    
      </ThemeProvider>
    );
  }
  
  static hide() {
    const divElem = document.getElementById("Relogin");
    if ( divElem ) {
      ReactDOM.unmountComponentAtNode(divElem);
      document.body.removeChild(divElem);
    }
  }

  static show(authenticate:Promise<void>) {
    const divElem = document.createElement("div");
    divElem.setAttribute("id", "Relogin");
    document.body.appendChild(divElem);

    return new Promise<void>((resolve, reject) => {
      const dom = document.getElementById("Relogin");

      const destroy = () => {
        ReactDOM.unmountComponentAtNode(dom);
        document.body.removeChild(dom);
      };

      const manualLogin = () => {        
        auth.openLoginPopup();
        return Promise.resolve();
      };

      const spLogin = () => {        
        auth.openSpLoginPopup();
        return Promise.resolve();
      };

      const onSignOut = () => {
        auth.signOut();
        destroy();
        //reject();
      };

      ReactDOM.render(<ReloginModal manualLogin={manualLogin} spLogin={spLogin} onSignOut={onSignOut} />, dom);
      const dialog = document.getElementById("reloginDialog") as any;      
      //dialog.showModal();
    });
  }
}
